// eslint-disable-next-line no-extend-native
Array.prototype.pushIfNotExist = function (element) {
	if (!this.inList(element)) {
		this.push(element);
	}
};

// eslint-disable-next-line no-extend-native
Array.prototype.inList = function (compare) {
	let result = false;
	this.forEach((element) => {
		if (element === compare) {
			result = true;
		}
	});
	return result;
};

// eslint-disable-next-line no-extend-native
Array.prototype.removeValue = function (value) {
	const index = this.indexOf(value);
	if (index > -1) {
		this.splice(index, 1);
	}
};

// eslint-disable-next-line no-extend-native
Array.prototype.pushIfUnique = function (item) {
	if (!this.includes(item)) {
		this.push(item);
	}
};

export function isObjectInList(list, index, value) {
	let object = getObjectInList(list, index, value);
	return !isEmptyObject(object);
}

export function getObjectInList(list, index, value) {
	return list.find((element) => element[index] === value);
}

export function isEmptyObject(object) {
	if (object && Object.keys(object).length && object.constructor === Object) {
		return false;
	}
	return true;
}

export function addObjetToList(list, object) {
	let result = list;
	result.push(object);
	return result;
}

export function removeObjectFromListByValues(list = [], listValues = [], index = "value") {
	return list.filter((element) => !listValues.includes(element[index]));
}

export function consolidateListObjects(firstList, secondList, searchParameters = [], operation = "intersection") {
	let result = [];

	const compare = (fistElement, secondElement) => {
		let found = false;
		try {
			if (searchParameters.length) {
				searchParameters.forEach((parameter) => {
					if (fistElement[parameter] === secondElement[parameter]) {
						found = true;
					}
				});
			}
		} catch (error) {
			console.log(error);
		}

		return found;
	};

	try {
		if (firstList.length || secondList.length) {
			switch (operation) {
				case "difference": {
					let onFirst = firstList.filter(
						(firstElement) => !secondList.some((secondElement) => compare(firstElement, secondElement))
					);
					let onSecond = secondList.filter(
						(secondElement) => !firstList.some((firstElement) => compare(firstElement, secondElement))
					);
					result = onFirst.concat(onSecond);
					break;
				}

				default: // Intersection
					result = secondList.filter((secondElement) => firstList.some((firstElement) => compare(firstElement, secondElement)));
					break;
			}
		}
	} catch (error) {
		console.log(error);
	}

	return result;
}

export function equalArray(arrayA, arrayB) {
	return (
		arrayA.length === arrayB.length &&
		arrayA.every(function (element) {
			return arrayB.includes(element);
		})
	);
}

export function getPrevious(list, index = "value", value) {
	if (!list) return null;
	if (list.at(0)[index] === value && list.length > 1) return list.at(1);

	for (let i = 0; i < list.length - 1; ++i) {
		if (list.at(i + 1)[index] === value) return list.at(i);
	}

	return null;
}

export function groupBy(arr, key) {
	return arr.reduce((rv, x) => {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	}, {});
}

export const range = (start, stop, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

export function findSimilarInObjectCollection(collection = [], index = "") {
	let similar = [];

	if (index) {
		let countWords = getCountWords(collection, index);
		let similarCounter = { ...countWords.firstWords, ...countWords.secondWords };

		for (const word in similarCounter) {
			if (similarCounter?.[word] > 1) {
				similar.push(word);
			}
		}
	}

	similar = [...new Set(similar)];
	return similar.map((element) => {
		let addObject = {};
		addObject[index] = `${element}*`;
		return addObject;
	});
}

const getCountWords = (collection = [], index = "") => {
	let firstWords = null;
	let secondWords = null;

	if (index) {
		firstWords = collection.reduce((prev, next) => {
			let firstWordNext = next[index].replace(/ .*/, "").trim();
			prev[firstWordNext] = prev[firstWordNext] + 1 || 1;
			return prev;
		}, {});

		secondWords = collection.reduce((prev, next) => {
			let firstTwoWords = next[index].split(" ").slice(0, 2).join(" ");
			firstTwoWords = firstTwoWords.trim();
			prev[firstTwoWords] = prev[firstTwoWords] + 1 || 1;
			return prev;
		}, {});
	}

	if (firstWords) {
		let filterObject = Object.entries(firstWords);
		let filtered = filterObject.filter(([key, value]) => key && value > 1);
		firstWords = Object.fromEntries(filtered);
	}

	if (secondWords) {
		let filterObject = Object.entries(secondWords);
		let filtered = filterObject.filter(([key, value]) => key && value > 1);
		secondWords = Object.fromEntries(filtered);
	}

	return {
		firstWords,
		secondWords,
	};
};
